import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

// css
import {CuerpoCompleto} from '../Css/StyledHeader.js'
import {FlexTabla, TextoCorto, FlechaAbajo} from '../Css/StyledPatient.js'

import { setearIdPacienteAction } from '../../actions/setearIdPacienteActions';
import { resetearConfigPacienteAction } from '../../actions/resetStoreActions';

import useReturnInitialState from '../../Hooks/useReturnInitialState.js';

export const ScreeningTablaPacientes = ({pacientes}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [returnState] = useReturnInitialState();


    const [listaPaciente, setListaPaciente] = useState(pacientes);
    const [orden, setOrden] = useState('asc');
    const [tipo, setTipo] = useState('')

    const Ordenar = (e, key, ordeno) => {
        e.preventDefault();
        const newList = JSON.parse(JSON.stringify(listaPaciente));
        if(ordeno === 'asc') {
            if(key === 'id') {
                newList.sort(function (a, b) {
                    if (a.id < b.id) {return -1;}
                    if (a.id > b.id) {return 1;}
                    return 0;
                });
            } else if (key === 'colegio') {
                newList.sort(function (a, b) {
                    if (a.colegio < b.colegio) {return -1;}
                    if (a.colegio > b.colegio) {return 1;}
                    return 0;
                });
            } else if (key === 'curso') {
                newList.sort(function (a, b) {
                    if (a.curso < b.curso) {return -1;}
                    if (a.curso > b.curso) {return 1;}
                    return 0;
                });
            } else if (key === 'edad') {
                newList.sort(function (a, b) {
                    if (a.edad < b.edad) {return -1;}
                    if (a.edad > b.edad) {return 1;}
                    return 0;
                });
            } else if (key === 'progreso') {
                newList.sort(function (a, b) {
                    if (a.progreso < b.progreso) {return -1;}
                    if (a.progreso > b.progreso) {return 1;}
                    return 0;
                });
            }
        } else {
            if(key === 'id') {
                newList.sort(function (a, b) {
                    if (a.id > b.id) {return -1;}
                    if (a.id < b.id) {return 1;}
                    return 0;
                });
            } else if (key === 'colegio') {
                newList.sort(function (a, b) {
                    if (a.colegio > b.colegio) {return -1;}
                    if (a.colegio < b.colegio) {return 1;}
                    return 0;
                });
            } else if (key === 'curso') {
                newList.sort(function (a, b) {
                    if (a.curso > b.curso) {return -1;}
                    if (a.curso < b.curso) {return 1;}
                    return 0;
                });
            } else if (key === 'edad') {
                newList.sort(function (a, b) {
                    if (a.edad > b.edad) {return -1;}
                    if (a.edad < b.edad) {return 1;}
                    return 0;
                });
            } else if (key === 'progreso') {
                newList.sort(function (a, b) {
                    if (a.progreso > b.progreso) {return -1;}
                    if (a.progreso < b.progreso) {return 1;}
                    return 0;
                });
            }
        }
        setListaPaciente(newList);
    }

    const seteoIdPaciente = (id, id_paciente_screening, progreso) => {
        if(progreso === "Completo") {
            return;
        }
        dispatch( resetearConfigPacienteAction() );
        const informacion = {
            payload: {
                id,
                nombre: id_paciente_screening
            }
        }
        dispatch( setearIdPacienteAction(informacion) );
        navigate(`/escritorio/screening/ejercicios`);
    }    

    useEffect(() => {
        setListaPaciente(pacientes);
    }, [pacientes])

    return ( 
        <CuerpoCompleto>
            <FlexTabla direction="column">
                <FlexTabla>
                    <FlexTabla direction="column"
                    xlg_margin="0.5rem 1rem 0rem 1rem" xlg_width="93%"
                    lg_margin="0.5rem 1rem 0rem 1rem" lg_width="93%"
                    dkt_margin="0.5rem 1rem 0rem 1rem" dkt_width="93%"
                    tb_margin="0.5rem 1rem 0rem 1rem" tb_width="93%"
                    min_margin="0.5rem 1rem 0rem 1rem" min_width="93%"
                    >
                        <FlexTabla>
                            <FlexTabla bgcolor="#E5E5E5" borderradius="10px" justify="space-between"
                            xlg_margin="0rem 0.5rem 0rem 0" xlg_padding="0.7rem 1rem" xlg_width="10%"
                            lg_margin="0rem 0.5rem 0rem 0" lg_padding="0.7rem 1rem" lg_width="10%"
                            dkt_margin="0rem 0.5rem 0rem 0" dkt_padding="0.7rem 1rem" dkt_width="10%"
                            tb_margin="0rem 0.5rem 0rem 0" tb_padding="0.7rem 1rem" tb_width="10%"
                            min_margin="0rem 0.5rem 0rem 0" min_padding="0.7rem 1rem" min_width="10%"
                            >
                                <TextoCorto>
                                    ID
                                </TextoCorto>
                                <FlechaAbajo alignself="center" flecha={tipo === 'id' ? true : false} ordenb={orden === 'desc' ? true : false} ordent={orden === 'asc' ? true : false} bgcolor={tipo === 'id' ? false : true}
                                    onClick={(e) => (Ordenar(e, "id", orden === 'asc' ? 'desc' : 'asc'), setTipo('id'), orden === 'asc' ? setOrden('desc') : setOrden('asc'))}
                                ></FlechaAbajo>
                            </FlexTabla>
                            
                            
                            <FlexTabla bgcolor="#E5E5E5" borderradius="10px" justify="space-between"
                            xlg_margin="0rem 0.5rem 0rem 0" xlg_padding="0.7rem 1rem" xlg_width="35%"
                            lg_margin="0rem 0.5rem 0rem 0" lg_padding="0.7rem 1rem" lg_width="35%"
                            dkt_margin="0rem 0.5rem 0rem 0" dkt_padding="0.7rem 1rem" dkt_width="35%"
                            tb_margin="0rem 0.5rem 0rem 0" tb_padding="0.7rem 1rem" tb_width="35%"
                            min_margin="0rem 0.5rem 0rem 0" min_padding="0.7rem 1rem" min_width="35%"
                            >
                                <TextoCorto>
                                    Colegio
                                </TextoCorto>
                                <FlechaAbajo alignself="center" flecha={tipo === 'colegio' ? true : false} ordenb={orden === 'desc' ? true : false} ordent={orden === 'asc' ? true : false} bgcolor={tipo === 'colegio' ? false : true}
                                    onClick={(e) => (Ordenar(e, "colegio", orden === 'asc' ? 'desc' : 'asc'), setTipo('colegio'), orden === 'asc' ? setOrden('desc') : setOrden('asc'))}
                                ></FlechaAbajo>
                            </FlexTabla>
                            <FlexTabla bgcolor="#E5E5E5" borderradius="10px" justify="space-between"
                            xlg_margin="0rem 0.5rem 0rem 0" xlg_padding="0.7rem 1rem" xlg_width="25%"
                            lg_margin="0rem 0.5rem 0rem 0" lg_padding="0.7rem 1rem" lg_width="25%"
                            dkt_margin="0rem 0.5rem 0rem 0" dkt_padding="0.7rem 1rem" dkt_width="25%"
                            tb_margin="0rem 0.5rem 0rem 0" tb_padding="0.7rem 1rem" tb_width="25%"
                            min_margin="0rem 0.5rem 0rem 0" min_padding="0.7rem 1rem" min_width="25%"
                            >
                                <TextoCorto>
                                    Curso
                                </TextoCorto>
                                <FlechaAbajo alignself="center" flecha={tipo === 'curso' ? true : false} ordenb={orden === 'desc' ? true : false} ordent={orden === 'asc' ? true : false} bgcolor={tipo === 'curso' ? false : true}
                                    onClick={(e) => (Ordenar(e, "curso", orden === 'asc' ? 'desc' : 'asc'), setTipo('curso'), orden === 'asc' ? setOrden('desc') : setOrden('asc'))}
                                ></FlechaAbajo>
                            </FlexTabla>
                            <FlexTabla bgcolor="#E5E5E5" borderradius="10px" justify="space-between"
                            xlg_margin="0rem 0rem 0rem 0" xlg_padding="0.7rem 1rem" xlg_width="12%"
                            lg_margin="0rem 0rem 0rem 0" lg_padding="0.7rem 1rem" lg_width="12%"
                            dkt_margin="0rem 0rem 0rem 0" dkt_padding="0.7rem 1rem" dkt_width="12%"
                            tb_margin="0rem 0rem 0rem 0" tb_padding="0.7rem 1rem" tb_width="12%"
                            min_margin="0rem 0rem 0rem 0" min_padding="0.7rem 1rem" min_width="12%"
                            >
                                <TextoCorto>
                                    Edad
                                </TextoCorto>
                                <FlechaAbajo alignself="center" flecha={tipo === 'edad' ? true : false} ordenb={orden === 'desc' ? true : false} ordent={orden === 'asc' ? true : false} bgcolor={tipo === 'edad' ? false : true}
                                    onClick={(e) => (Ordenar(e, "edad", orden === 'asc' ? 'desc' : 'asc'), setTipo('edad'), orden === 'asc' ? setOrden('desc') : setOrden('asc'))}
                                ></FlechaAbajo>
                            </FlexTabla>
                            <FlexTabla bgcolor="#E5E5E5" borderradius="10px" justify="space-between"
                            xlg_margin="0rem 0rem 0rem 0" xlg_padding="0.7rem 1rem" xlg_width="18%"
                            lg_margin="0rem 0rem 0rem 0" lg_padding="0.7rem 1rem" lg_width="18%"
                            dkt_margin="0rem 0rem 0rem 0" dkt_padding="0.7rem 1rem" dkt_width="18%"
                            tb_margin="0rem 0rem 0rem 0" tb_padding="0.7rem 1rem" tb_width="18%"
                            min_margin="0rem 0rem 0rem 0" min_padding="0.7rem 1rem" min_width="18%"
                            >
                                <TextoCorto>
                                    Progreso
                                </TextoCorto>
                                <FlechaAbajo alignself="center" flecha={tipo === 'progreso' ? true : false} ordenb={orden === 'desc' ? true : false} ordent={orden === 'asc' ? true : false} bgcolor={tipo === 'progreso' ? false : true}
                                    onClick={(e) => (Ordenar(e, "progreso", orden === 'asc' ? 'desc' : 'asc'), setTipo('progreso'), orden === 'asc' ? setOrden('desc') : setOrden('asc'))}
                                ></FlechaAbajo>
                            </FlexTabla>
                        </FlexTabla>
                        <div>
                            {listaPaciente.map((item,i) => (
                                <FlexTabla border="2px solid #FF9B2A" borderradius="10px" boxshadow="2px 4px 2px 1px rgba(229, 229, 229, 1)"
                                key={i}
                                xlg_margin="1.8rem 0rem 0rem 0" xlg_padding="0.5rem 0.2rem 0.5rem 0.4rem"
                                lg_margin="1.8rem 0rem 0rem 0" lg_padding="0.5rem 0.2rem 0.5rem 0.4rem"
                                dkt_margin="1.8rem 0rem 0rem 0" dkt_padding="0.5rem 0.2rem 0.5rem 0.4rem"
                                tb_margin="1.8rem 0rem 0rem 0" tb_padding="0.5rem 0.2rem 0.5rem 0.4rem"
                                min_margin="1.8rem 0rem 0rem 0" min_padding="0.5rem 0.2rem 0.5rem 0.4rem"
                                    onClick={() => seteoIdPaciente(item.id, item.id_paciente_screening, item.progreso)}
                                >
                                    <TextoCorto textalign="start" borderright="1px solid black" cursor="pointer"
                                    xlg_margin="0rem 0 0rem 0" xlg_padding="0.3rem 0rem 0.3rem 0.4rem" xlg_width="10%"
                                    lg_margin="0rem 0 0rem 0" lg_padding="0.3rem 0rem 0.3rem 0.4rem" lg_width="10%"
                                    dkt_margin="0rem 0 0rem 0" dkt_padding="0.3rem 0rem 0.3rem 0.4rem" dkt_width="10%"
                                    tb_margin="0rem 0 0rem 0" tb_padding="0.3rem 0rem 0.3rem 0.4rem" tb_width="10%"
                                    min_margin="0rem 0 0rem 0" min_padding="0.3rem 0rem 0.3rem 0.4rem" min_width="10%"
                                    >
                                        {item.id_paciente_screening}
                                    </TextoCorto>
                                    <TextoCorto textalign="start" borderright="1px solid black" cursor="pointer"
                                    xlg_margin="0rem 0 0rem 0" xlg_padding="0.3rem 0rem 0.3rem 0.4rem" xlg_width="35%"
                                    lg_margin="0rem 0 0rem 0" lg_padding="0.3rem 0rem 0.3rem 0.4rem" lg_width="35%"
                                    dkt_margin="0rem 0 0rem 0" dkt_padding="0.3rem 0rem 0.3rem 0.4rem" dkt_width="35%"
                                    tb_margin="0rem 0 0rem 0" tb_padding="0.3rem 0rem 0.3rem 0.4rem" tb_width="35%"
                                    min_margin="0rem 0 0rem 0" min_padding="0.3rem 0rem 0.3rem 0.4rem" min_width="35%"
                                    >
                                        {item.colegio}
                                    </TextoCorto>
                                    <TextoCorto textalign="start" borderright="1px solid black" cursor="pointer"
                                    xlg_margin="0rem 0 0rem 0" xlg_padding="0.3rem 0rem 0.3rem 0.4rem" xlg_width="25%"
                                    lg_margin="0rem 0 0rem 0" lg_padding="0.3rem 0rem 0.3rem 0.4rem" lg_width="25%"
                                    dkt_margin="0rem 0 0rem 0" dkt_padding="0.3rem 0rem 0.3rem 0.4rem" dkt_width="25%"
                                    tb_margin="0rem 0 0rem 0" tb_padding="0.3rem 0rem 0.3rem 0.4rem" tb_width="25%"
                                    min_margin="0rem 0 0rem 0" min_padding="0.3rem 0rem 0.3rem 0.4rem" min_width="25%"
                                    >
                                        {item.curso}
                                    </TextoCorto>
                                    <TextoCorto textalign="center" borderright="1px solid black"  cursor="pointer"
                                    xlg_margin="0rem 0 0rem 0" xlg_padding="0.3rem 0rem 0.3rem 0.4rem" xlg_width="12%"
                                    lg_margin="0rem 0 0rem 0" lg_padding="0.3rem 0rem 0.3rem 0.4rem" lg_width="12%"
                                    dkt_margin="0rem 0 0rem 0" dkt_padding="0.3rem 0rem 0.3rem 0.4rem" dkt_width="12%"
                                    tb_margin="0rem 0 0rem 0" tb_padding="0.3rem 0rem 0.3rem 0.4rem" tb_width="12%"
                                    min_margin="0rem 0 0rem 0" min_padding="0.3rem 0rem 0.3rem 0.4rem" min_width="12%"
                                    >
                                        {item.edad} a {item.mes} m
                                    </TextoCorto>
                                    <TextoCorto textalign="center" cursor="pointer"
                                    xlg_margin="0rem 0 0rem 0" xlg_padding="0.3rem 0rem 0.3rem 0.4rem" xlg_width="18%"
                                    lg_margin="0rem 0 0rem 0" lg_padding="0.3rem 0rem 0.3rem 0.4rem" lg_width="18%"
                                    dkt_margin="0rem 0 0rem 0" dkt_padding="0.3rem 0rem 0.3rem 0.4rem" dkt_width="18%"
                                    tb_margin="0rem 0 0rem 0" tb_padding="0.3rem 0rem 0.3rem 0.4rem" tb_width="18%"
                                    min_margin="0rem 0 0rem 0" min_padding="0.3rem 0rem 0.3rem 0.4rem" min_width="18%"
                                    >
                                        {item.progreso}
                                    </TextoCorto>
                                </FlexTabla>
                            ))}
                        </div>
                    </FlexTabla>
                    <FlexTabla
                    xlg_margin="0rem 0rem 0rem 0rem" xlg_width="7%"
                    lg_margin="0rem 0rem 0rem 0rem" lg_width="7%"
                    dkt_margin="0rem 0rem 0rem 0rem" dkt_width="7%"
                    tb_margin="0rem 0rem 0rem 0rem" tb_width="7%"
                    min_margin="0rem 0rem 0rem 0rem" min_width="7%"
                    >
                        <Link to={"/escritorio/screening/nuevo-paciente"} style={{ textDecoration: 'none' }}>
                            <TextoCorto fontsize="3rem" cursor="pointer" color="#000000"
                                onClick={() => returnState(['estado.error','estado.loading'])}
                            >
                                    +
                            </TextoCorto>
                        </Link>
                    </FlexTabla>
                </FlexTabla>
            </FlexTabla>
        </CuerpoCompleto>
    );
}